"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Reference_1 = require("../types/Reference");
var domUtilsReference = new Reference_1.Reference({});
/**
 * Scroll to element
 *
 * @param element Element to scroll into view
 * @param offset Set vertical offset, default 0px
 */
function scrollTo(element, offset) {
    if (offset === void 0) { offset = 0; }
    var bodyRect = document.body.getBoundingClientRect();
    var elemRect = element.getBoundingClientRect();
    var scroll = elemRect.top - bodyRect.top - offset;
    window.scrollTo({ top: scroll, behavior: 'smooth' });
}
exports.scrollTo = scrollTo;
/**
 * Give focus to a given element
 *
 * @param element Element to give focus
 * @param force If the function should add tabindex="-1". Use this paramter with caution. Note that it will only add tabindex="-1" if tabindex does not exist.
 */
function focus(element, force) {
    if (force === void 0) { force = false; }
    var hasTabindexAttribute = element.getAttribute('tabindex');
    if (force && hasTabindexAttribute === null) {
        element.setAttribute('tabindex', '-1');
    }
    element.focus();
}
exports.focus = focus;
/**
 * Check if an element is visible in the dom
 * @param element
 */
function isVisible(element) {
    return Boolean(element.offsetWidth || element.offsetHeight || element.getClientRects().length);
}
/**
 * Find all visible elements
 * @param element
 */
function findVisibleFocusableElements(element) {
    var selector = "a[href], area[href], input:not([disabled]), select:not([disabled]),\n        textarea:not([disabled]), button:not([disabled]), iframe,\n        object:not([disabled]), embed, *[tabindex],\n         *[contenteditable]";
    return Array.from(element.querySelectorAll(selector)).filter(isVisible);
}
exports.findVisibleFocusableElements = findVisibleFocusableElements;
/**
 * Focus first focusable element among given root element's hierarchy.
 *
 * @param rootElement Root element.
 */
function focusFirst(rootElement) {
    var element = findVisibleFocusableElements(rootElement).shift();
    if (element) {
        focus(element);
    }
}
exports.focusFirst = focusFirst;
/**
 * Focus last focusable element among given root element's hierarchy.
 *
 * @param rootElement Root element.
 */
function focusLast(rootElement) {
    var element = findVisibleFocusableElements(rootElement).pop();
    if (element) {
        focus(element);
    }
}
exports.focusLast = focusLast;
/**
 * Add a listener to each item in the list of elements
 * @param elements
 * @param listener
 */
function addFocusListener(elements, listener) {
    for (var _i = 0, elements_1 = elements; _i < elements_1.length; _i++) {
        var element = elements_1[_i];
        element.addEventListener('focus', listener);
    }
}
exports.addFocusListener = addFocusListener;
/**
 * Remove listener for each item in the list of elements
 * @param elements
 * @param listener
 */
function removeFocusListener(elements, listener) {
    for (var _i = 0, elements_2 = elements; _i < elements_2.length; _i++) {
        var element = elements_2[_i];
        element.removeEventListener('focus', listener);
    }
}
exports.removeFocusListener = removeFocusListener;
/**
 * Restore focus to a previous element. Use this in combination with @saveFocus
 */
function restoreFocus() {
    var _a;
    (_a = domUtilsReference.ref.oldFocus) === null || _a === void 0 ? void 0 : _a.focus();
}
exports.restoreFocus = restoreFocus;
/**
 * Save a DOM reference to the active element for later use.
 * @param document
 */
function saveFocus(document) {
    if (document.activeElement instanceof HTMLElement) {
        domUtilsReference.ref.oldFocus = document.activeElement;
    }
}
exports.saveFocus = saveFocus;
/**
 * Check if ValidatableHTMLElement is of type radiobutton or checkbox
 * @param element
 */
function isRadiobuttonOrCheckbox(element) {
    return element instanceof HTMLInputElement && (element.type === 'radio' || element.type === 'checkbox');
}
exports.isRadiobuttonOrCheckbox = isRadiobuttonOrCheckbox;
/**
 * Check if ValidatableHTMLElement is a form element
 * @param element
 */
function isValidatableFormElement(element) {
    if (element instanceof HTMLInputElement || element instanceof HTMLSelectElement || element instanceof HTMLTextAreaElement) {
        return true;
    }
    return false;
}
exports.isValidatableFormElement = isValidatableFormElement;
//# sourceMappingURL=DomUtils.js.map